import social from "./social";
import study from "./study";

/**
 * 华博特项目接口文档
 */
export default {
  social,
  study,
};
